<app-filter-menu-skeleton
    [secondaryActionButton]="{
        label: 'clearAll',
        type: ButtonType.UNDERLINE,
    }"
    (secondaryButtonClicked)="resetSelection()"
    (submit)="submit()">
    <div class="pr-4">
        <app-form-filter-options />
        <app-operators-filter-options />
        <app-entity-status-filter-options />
    </div>
</app-filter-menu-skeleton>
